import AgTechMetric from '@agtech/web/components/Metrics/AgTechMetric';
import AgTechNoRecordsPage from '@agtech/web/components/Pages/Error/AgTechNoRecordsPage';
import { AgTechMoneyFormatter } from '@agtech/web/utilities/AgTechUtilities';
import { useInvoiceDataGetUnProcessedSalesQuery } from '@sales/data/invoicing/InvoicingDataQueries';
import _ from 'lodash';
import React from 'react'
import InvoiceUnprocessedSalesGrid from '../components/grids/InvoiceUnprocessedSalesGrid';
import AgTechQueryLoadingSurface from '@agtech/core/data/queries/AgTechQueryLoadingSurface';
import LotSellingViewDialog from '../../lots/dialogs/LotSellingViewDialog';

const SaleInvoicingUnprocessedLotsPage = () => {
    let getUnprocessedSalesQuery = useInvoiceDataGetUnProcessedSalesQuery();

    return (
        <AgTechQueryLoadingSurface query={getUnprocessedSalesQuery}>
            {(unprocessedSales) => {
                return unprocessedSales.length > 0 ? (
                    <div className='stretched column-based flex'>
                        <div id='sale-invoicing-unprocessed-grid' className='flexed area-left flex'>
                            <InvoiceUnprocessedSalesGrid unprocessedSales={unprocessedSales} />
                        </div>
                        <div className='tall row-based vertical-pane area-right w-240'>
                            <div id='sale-invoicing-unprocessed-sales-metric'>
                                <AgTechMetric header='Unprocessed Sales' value={unprocessedSales.length.toString()} />
                            </div>
                            <div id='sale-invoicing-unprocessed-lots-metric'>
                                <AgTechMetric header='Sold Lots Not Invoiced' value={_.sumBy(unprocessedSales, d => d.numberOfLots).toString()} />
                            </div>
                            <div id='sale-invoicing-unprocessed-total-metric'>
                                <AgTechMetric header='Total Sales Not Invoiced' value={AgTechMoneyFormatter.format(_.sumBy(unprocessedSales, d => d.totalPurchasePrice))} />
                            </div>
                        </div>
                    </div>
                ) : (
                    <AgTechNoRecordsPage
                        message='There are no sales ready for invoicing right now.'
                        action={{
                            prompt: 'To sell lots, please click the button below',
                            button: () => <LotSellingViewDialog.Button classes='button-highlight' icon={'fas fa-edit'} />
                        }}
                    />
                );
            }}
        </AgTechQueryLoadingSurface>
    );
};

export default SaleInvoicingUnprocessedLotsPage;
